<template lang='pug'>
  div
    v-menu(offset-y left  v-if='testSuite')
      template(v-slot:activator='{on}')
        v-progress-circular.progress-item(v-on='on' :size='size' :width='2' indeterminate color='primary lighten-1' @click.native.stop='')
      v-list
        v-list-item(@click='cancelRun()')
          v-list-item-title
            | Cancel
    v-progress-circular.progress-item(:size='size' :width='2' indeterminate color='primary lighten-1' v-if='!testSuite')
</template>

<script>
import TestRun from '../api/testRun';
import Notifications from '../services/notification.service';


export default {
  name: 'BionicMetricsRunningIndicatorCircular',
  props: {
    size: {
      type: Number,
      default: 20
    },
    testSuite: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    async cancelRun() {
      await TestRun.cancel(this.testSuite.runGuid);
      this.$emit('cancelled', this.testSuite);
      Notifications.toast(`Tests cancelled for ${this.testSuite.name}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
